if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}



// Zero-price toggle — nasconde prezzo + Add-to-cart quando il prezzo della variante è 0
if (!window.__zeroPriceToggleInstalled) {
  window.__zeroPriceToggleInstalled = true;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(function (productInfo) {
      if (!productInfo) return;

      var priceEl = productInfo.querySelector('[id^="price-"], .product__price, .price');
      var addToCartBtns = Array.from(productInfo.querySelectorAll('button[name="add"], button[id^="ProductSubmitButton-"], button[id^="AddToCart"]'));
      var variantSelect = productInfo.querySelector('select[name="id"], input[name="id"]');

      function safeSetDisabled(btn, disabled) {
        try {
          if (disabled) {
            btn.setAttribute('disabled', 'disabled');
            btn.setAttribute('aria-hidden', 'true');
            btn.style.display = 'none';
          } else {
            btn.removeAttribute('disabled');
            btn.setAttribute('aria-hidden', 'false');
            btn.style.display = '';
          }
        } catch (e) { /* ignore */ }
      }

      function setButtonsVisible(visible) {
        addToCartBtns.forEach(function (b) { if (b) safeSetDisabled(b, !visible); });
      }

      function toNumber(value) {
        if (value === null || typeof value === 'undefined') return NaN;
        if (typeof value === 'number') return value;
        var cleaned = String(value).replace(/\s/g, '').replace(',', '.').replace(/[^\d.-]/g, '');
        return Number(cleaned);
      }

      function updateUIFromPrice(value) {
        var n = toNumber(value);
        var isZero = isFinite(n) && n === 0;
        if (priceEl) priceEl.style.display = isZero ? 'none' : '';
        setButtonsVisible(!isZero);
      }

      // Init: prefer data-attribute, poi oggetto globale, poi testo nel DOM
      try {
        var priceNode = productInfo.querySelector('[data-variant-price]');
        if (priceNode) {
          var p = priceNode.getAttribute('data-variant-price');
          updateUIFromPrice(p);
        } else if (window.productSingleObject && window.productSingleObject.selected_or_first_available_variant) {
          updateUIFromPrice(window.productSingleObject.selected_or_first_available_variant.price);
        } else if (priceEl && priceEl.textContent) {
          var digits = priceEl.textContent.replace(/[^\d]/g, '');
          if (digits) updateUIFromPrice(Number(digits));
        }
      } catch (e) { /* init best-effort */ }

      // Listen for variant change events (covers Dawn variations)
      ['variant:change', 'product:variant:change', 'product:variant:updated'].forEach(function (evtName) {
        document.addEventListener(evtName, function (e) {
          if (!e || !e.detail || !e.detail.variant) return;
          var v = e.detail.variant;
          try {
            // evita cross-talk tra più product-info sulla stessa pagina
            if (productInfo.dataset && productInfo.dataset.productId) {
              var pid = parseInt(productInfo.dataset.productId, 10);
              var vid = parseInt(v.product_id || v.productId || v.id, 10);
              if (!isNaN(pid) && !isNaN(vid) && pid !== vid) return;
            }
            if (typeof v.price !== 'undefined') updateUIFromPrice(v.price);
            else if (typeof v.price_amount !== 'undefined') updateUIFromPrice(v.price_amount);
          } catch (err) { /* ignore */ }
        });
      });

      // Fallback: ascolta il select/input delle varianti locale
      if (variantSelect) {
        try {
          variantSelect.addEventListener('change', function () {
            var opt = variantSelect.options ? variantSelect.options[variantSelect.selectedIndex] : null;
            var p = opt && opt.getAttribute ? opt.getAttribute('data-price') : null;
            if (p !== null) {
              var parsed = toNumber(p);
              if (!isNaN(parsed)) updateUIFromPrice(parsed);
              return;
            }
            if (window.productSingleObject && window.productSingleObject.selected_or_first_available_variant) {
              updateUIFromPrice(window.productSingleObject.selected_or_first_available_variant.price);
            }
          });
        } catch (e) { /* ignore */ }
      }
    });
  });
}